t = require('views/internal/teacup-with-helpers')('board_background_options')

module.exports = ->
  t.p '.u-font-weight-bold.quiet', ->
    t.format 'display-type'

  t.ul '.pop-over-list', ->

    t.li ->
      t.a '.js-select-option', { href: '#', 'data-background-display-type': 'cover' }, ->
        t.check !t.mustacheVar('tile'), 'cover'

    t.li ->
      t.a '.js-select-option', { href: '#', 'data-background-display-type': 'tile' }, ->
        t.check t.mustacheVar('tile'), 'tile'

  t.hr()

  t.p '.u-font-weight-bold.quiet', ->
    t.format 'board-text'

  t.ul '.pop-over-list', ->

    t.li ->
      t.a '.js-select-option', { href: '#', 'data-board-brightness': 'dark' }, ->
        t.check t.mustacheVar('brightnessDark'), 'light'

    t.li ->
      t.a '.js-select-option', { href: '#', 'data-board-brightness': 'light' }, ->
        t.check t.mustacheVar('brightnessLight'), 'dark'

  t.hr()

  t.a '.quiet-button.js-delete-background', { href: '#' }, ->
    t.format 'delete-background'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/board_background_options.coffee